<template>
  <div>
    <div class="tw-flex tw-flex-col sm:tw-items-center tw-justify-center tw-h-screen tw-bg-gray-100"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
//import Avatar from "@/components/Avatar.vue";
import EventBus from "@/utils/global-events.js";

export default {
  components: {
    // Avatar,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      business: {},
      primaryColor: null,
      secondaryColor: null,
    };
  },
  computed: {
    ...mapGetters("cognito", { userId: "id", userName: "name" }),
    businessUserInviteId() {
      return this.$route.query.i;
    },
    accepted() {
      return this.$route.query.a;
    },
    changeOrg() {
      return this.$route.query.changeOrg;
    },
  },
  mounted() {
    if (this.accepted == "true") {
      this.accept();
    } else if (this.changeOrg == "true") {
      this.changeOrganization(this.businessId);
      this.$router.push(`/businesses/${this.businessId}/dashboard`);
    }
  },
  methods: {
    ...mapActions("organization", ["changeOrganization"]),
    accept() {
      this.$axios.post(`/businesses/${this.businessId}/user-invites/${this.businessUserInviteId}/accept`, { userId: this.userId }).then(() => {
        window.location = `/businesses/${this.businessId}/user-invites/accept?changeOrg=true`;
        EventBus.$emit("GLOBAL_NOTIFY", { title: "Business Invite Accepted", message: "Business invite accepted." });
      });
    },
    reject() {
      this.$axios.post(`/businesses/${this.businessId}/user-invites/${this.businessUserInviteId}/reject`, { userId: this.userId }).then(() => {
        this.$router.push("/");
        EventBus.$emit("GLOBAL_NOTIFY", { title: "Business Invite Rejected", message: "Business invite rejected." });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.jumbotron {
  background-color: transparent;
}
</style>
